import React from "react";
import LegalShell, { LegalSection } from "./LegalShell";
import { LEGAL } from "../../lib/legalConfig";

/**
 * /legal/cookies — Cookie Notice.
 *
 * ⚠️ LAWYER-APPROVED COPY (5 February 2026). New page added on counsel
 * sign-off — referenced from Privacy Policy §9.
 */
export default function CookiesPage() {
  return (
    <LegalShell
      title="Cookie Notice"
      effectiveDate={LEGAL.COOKIES_EFFECTIVE_DATE}
      lastUpdated={LEGAL.COOKIES_EFFECTIVE_DATE}
      testid="legal-cookies"
      intro={
        <>
          How Xchangely uses cookies and similar technologies on the site,
          and how you can control them.
        </>
      }
    >
      <LegalSection id="how-we-use" title="How we use cookies">
        <p>
          Xchangely uses cookies and similar technologies to operate the
          site, keep you signed in securely, remember your preferences, and
          understand how the site is used so we can improve it.
        </p>
      </LegalSection>

      <LegalSection id="types" title="Types of cookies we use">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Strictly necessary</strong> — required for the site to
            work (security, session, sign-in). These cannot be switched off.
          </li>
          <li>
            <strong>Functional</strong> — remember your preferences.
          </li>
          <li>
            <strong>Analytics</strong> — help us understand site usage so we
            can improve it.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="managing" title="Managing cookies">
        <p>
          You can control cookies through your browser settings. Blocking
          strictly necessary cookies may stop parts of the site from
          working.
        </p>
      </LegalSection>

      <LegalSection id="changes" title="Changes">
        <p>
          We may update this notice; the current version is always posted
          here.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
